<template>
  <p class="item_detail_text">{{ text }}</p>
</template>

<script>
export default {
  name: "CheckListItemDetailText",
  data: () => ({}),
  methods: {},
  created() {},
  components: {},
  props: ["text"]
};
</script>

<style scoped>
.item_detail_text {
  border: 1px dashed #707f89;
  border-radius: 12px;
  color: #707f89;
  font-size: 12px;
  width: 90%;
  text-align: left;
  padding-left: 10px;
  background-color: #ffffff;
}
</style>
